import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import i18n from '@shared/config/i18n';
import { getRizers } from './api';
import type { GetRizersPayload, GetRizersResponse, Gate } from './types';

const { t } = i18n;

export const RizersControlGate = createGate<Gate>();

const fxGetRizers = createEffect<GetRizersPayload, GetRizersResponse, Error>().use(
  getRizers
);

export const rizersQuery = createQuery({
  name: 'Rizers',
  effect: fxGetRizers,
  mapData: ({ result }) =>
    Array.isArray(result?.rizers)
      ? result.rizers.map((rizerNumber) => {
          if (String(rizerNumber) === '0') {
            return { id: 0, label: t('gate') };
          }

          return { id: rizerNumber, label: `${t('rizer')} №${rizerNumber}` };
        })
      : [],
});

sample({
  clock: RizersControlGate.state,
  source: RizersControlGate.status,
  filter: (status, { buildingIds }) => Boolean(status && buildingIds.length === 1),
  fn: (_, { buildingIds }) => ({ building_id: buildingIds[0] }),
  target: rizersQuery.start,
});
